import * as S from './styles';
import QITechLogoTertiary from '../../../theme/assets/qi_tech_logo_tertiary.svg'

export const PoweredByQITech = () => (
    <S.Container href="https://qitech.com.br/" target="_blank" rel="noopener noreferrer">
        <img src={QITechLogoTertiary} width={18} height={18} alt="QI Tech" />
        <S.PoweredBy>Powered by</S.PoweredBy>
        <S.Brand>QI Tech</S.Brand>
    </S.Container>
);
